import styled from 'styled-components';
import { getInvertedColor } from '@elfsight/widget-utils';
import type { DefaultComponentProps } from '../../types';

interface BadgeProps extends DefaultComponentProps {
  color?: string;
  textSize?: number;
}

export function Badge({
  children,
  color = 'transparent',
  textSize = 11,
  ...forwardingProps
}: BadgeProps) {
  const textColor = getInvertedColor(color, [
    'rgb(255, 255, 255)',
    'rgb(29, 33, 41)'
  ]);

  return (
    <Container
      {...forwardingProps}
      _backgroundColor={color}
      _textColor={textColor}
      _textSize={textSize}
    >
      {children}
    </Container>
  );
}

const Container = styled.div<{
  _textSize: number;
  _backgroundColor: string;
  _textColor: string;
}>`
  padding: 4px 6px;
  border-radius: 4px;
  text-transform: uppercase;
  font-weight: bold;
  transition: opacity 0.3s;
  opacity: 0.9;
  font-size: ${({ _textSize }) => _textSize}px;
  background: ${({ _backgroundColor }) => _backgroundColor};
  color: ${({ _textColor }) => _textColor};

  &:hover {
    opacity: 1;
  }
`;
